<template>
  <div id="app">
    <b-container
      class="d-sm-none text-center"
      style="background: black; padding:5px;"
    >
      <img
        id="mobilelogo"
        src="./assets/logo.png"
        height="40"
        alt="Logo"
        class="ml-20"
        role="logo"
      />

      <h3 class style="color: white;">Teacher Institute Registration</h3>
    </b-container>
    <b-container fluid style="width: auto;">
      <b-navbar type="light" class="mb-4" role="banner">
        <b-container>
          <b-navbar-brand
            class="d-none d-sm-none d-md-block align-top"
            href="#"
          >
            <img
              id="logo"
              src="./assets/WCU_Main-new-1.svg"
              height="60"
              class="light-img img-responsive"
              alt="Western Colorado University Logo"
              role="logo"
            />
            <div class="dark-img" style="display: none">
              <img
                src="./assets/WCU_Main-dark.png"
                height="auto"
                width="200"
                class="img-responsive d-inline-block align-top"
                alt="Western Colorado University Logo"
                role="logo"
              />
            </div>
          </b-navbar-brand>
          <div class="buttons">
            <b-nav pills class>
              <b-nav-item>
                <router-link to="/">
                  <b-button variant="outline-danger">
                    <b-icon-house-fill
                      class="d-none d-sm-inline d-md-inline"
                    ></b-icon-house-fill
                    >Home
                  </b-button>
                </router-link>
              </b-nav-item>

              <b-nav-item>
                <router-link to="/cart">
                  <b-button variant="outline-danger">
                    <b-icon-credit-card
                      class="d-none d-sm-inline d-md-inline"
                    ></b-icon-credit-card
                    >Shopping Cart
                  </b-button>
                </router-link> </b-nav-item
              ><b-nav-item class="d-none d-sm-none d-md-block">
                <b-dropdown
                  right
                  class="d-none d-sm-inline d-md-inline m-md-2"
                  id="dropdown-1"
                  text="Help"
                  variant="outline-danger"
                >
                  <!-- <b-dropdown-item
                    ><a href="mailto:extendedstudies@western.edu"
                      >Email</a
                    ></b-dropdown-item
                  >
                  <b-dropdown-divider></b-dropdown-divider> -->
                  <b-dropdown-item>
                    <a href="tel:970.943.2885"
                      >Phone: 970.943.2885</a
                    ></b-dropdown-item
                  >
                </b-dropdown>
              </b-nav-item>
              <b-nav-item v-if="user.userId > 0">
                <router-link to="/logout">
                  <b-button variant="outline-danger">
                    <b-icon-unlock-fill></b-icon-unlock-fill>Log Out
                  </b-button>
                </router-link>
              </b-nav-item>

              <b-nav-item-dropdown v-if="user.userId > 0" no-caret>
                <template slot="button-content">
                  <slot>
                    <b-button variant="outline-danger">
                      <b-icon-three-dots></b-icon-three-dots>Menu
                    </b-button>
                  </slot>
                </template>

                <div v-if="hasRole('admin')">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <router-link to="courses">Manage Courses</router-link>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="configure">Configure</router-link>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="kanban">Tasks</router-link>
                  </b-dropdown-item>
                </div>

                <div v-if="hasRole('staff')">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <router-link to="cancel">Cancel App</router-link>
                  </b-dropdown-item>
                </div>

                <div v-if="hasRole('support')">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <router-link to="application">Push Application</router-link>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="accept">Accept Students</router-link>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="registration"
                      >Register Students</router-link
                    >
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="report">Reporting</router-link>
                  </b-dropdown-item>
                </div>

                <div v-if="hasRole('security')">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <router-link to="members">Manage Members</router-link>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="access">Access Control</router-link>
                  </b-dropdown-item>
                </div>
              </b-nav-item-dropdown>
            </b-nav>
          </div>
        </b-container>
      </b-navbar>
      <b-container>
        <div id="app" role="main">
          <router-view />
        </div>
      </b-container>
      <footer class="my-5 pt-5 text-muted text-center text-small" role="footer">
        <p class="mb-1">
          <router-link to="/login">© 2022</router-link>
        </p>
      </footer>
    </b-container>
  </div>
</template>

<script>
document.title = "TI Registration | Western Colorado University";
import { mixins } from "./mixins";

export default {
  name: "vue",
  mixins: [mixins],
  created() {
    if (
      "-ms-scroll-limit" in document.documentElement.style &&
      "-ms-ime-align" in document.documentElement.style
    ) {
      // detect it's IE11
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
  },
};
</script>

<style>
body {
  background: rgba(249, 249, 249, 1) !important;
}

#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0e0f11;
  font-size: 16px;
  line-height: 21px;
}

.navbar {
  height: 110px;
  -webkit-box-shadow: 0px 3px 6px 0px rgba(218, 218, 218, 1);
  -moz-box-shadow: 0px 3px 6px 0px rgba(218, 218, 218, 1);
  box-shadow: 0px 3px 6px 0px rgba(218, 218, 218, 1);
}
.dropdown-item a:hover {
  color: rgba(167, 25, 48, 1) !important;
}
.dropdown-item .btn-outline-danger {
  color: #fff !important;
}
.dropdown-item a {
  color: rgba(167, 25, 48, 1);
}
.navbar-text {
  color: #fff !important;
}

#top {
  height: 57px;
  color: #fff;
}

a.btn:hover {
  cursor: pointer;
}

span.required::after {
  content: "*";
  color: #0f0c0d !important;
}

h1 {
  text-transform: uppercase;
  color: rgba(87, 88, 92, 1);
  letter-spacing: 3px;
  text-align: center;
}

h1:after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 10%;
  padding-top: 5px;
  border-bottom: 8px solid rgba(167, 25, 48, 1);
  margin-bottom: 10px;
}

h2 {
  color: rgba(87, 88, 92, 1);
  letter-spacing: 3px;
  text-align: center !important;
}

.badge-danger {
  background-color: #a71930 !important;
}

.btn-primary,
.btn-danger {
  color: #ffffff !important;
  border-color: #a71930 !important;
  background-color: #a71930 !important;
}

.btn-danger:hover {
  background-color: #911930 !important;
  border-color: #911930 !important;
}

.btn-outline-primary,
.btn-outline-danger {
  color: #57585c !important;
  border-color: #a71930 !important;
}

.btn-outline-danger:hover {
  background: #a71930 !important;
  color: #ffffff !important;
}

.container-fluid {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

a {
  color: #2606b1 !important;
}

.jumbotron {
  background: #fff !important;
}

a:hover {
  text-decoration: underline;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff !important;
  background-color: #a71930 !important;
  border-color: #a71930 !important;
}
@media screen and (max-width: 768px) {
  h1 {
    font-size: 20px !important;
  }
  .buttons {
    margin: auto !important;
  }
}
@media screen and (max-width: 766px) {
  a.navbar-brand img {
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 29px;
  }
}

/* Dark Mode */
@media (prefers-color-scheme: dark) {
  table {
    color: #fff !important;
  }
  .card {
    border: 1px solid #fff !important;
  }
  .page-item.disabled .page-link {
    color: #fff;
    pointer-events: none;
    cursor: auto;
    background-color: black !important;
    border-color: #dee2e6;
  }
  a.nav-link:active {
    background: #000 !important;
  }
  span.required::after {
    content: "*";
    color: red !important;
  }
  hr {
    border-top: 1px solid rgba(255, 255, 255, 1) !important;
  }
  /* Shows Dark Mode-Only Content, Like Images */
  .dark-img {
    display: block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    max-width: inherit !important;
    line-height: auto !important;
    margin-top: 0px !important;
    visibility: inherit !important;
  }
  body {
    background: #000 !important;
    color: #fff !important;
  }
  .list-group-item {
    background: #000 !important;
    border: 1px solid #dadada !important;
  }
  .navbar {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    background: #000 !important;
  }
  .navbar .btn {
    color: #fff !important;
  }
  .btn-outline-primary,
  .btn-outline-danger {
    background-color: #a71930 !important;
    color: #fff !important;
  }
  .btn-outline-danger:hover {
    background-color: #b90c29 !important;
  }
  .dropdown-menu {
    background: #000 !important;
    color: #fff !important;
  }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    background: none !important;
  }
  ul.menu {
    background: #000 !important;
  }
  .bg-white {
    background: #000 !important;
  }
  .jumbotron {
    background: #000 !important;
    border: 1px solid #dadada !important;
    color: #fff !important;
  }
  .birthday-picker_dropdown {
    background: #000 !important;
  }
  .birthday-picker_dropdown-body {
    border: 1px solid #dadada !important;
  }
  .birthday-picker td a {
    color: #dadada !important;
  }
  .birthday-picker td a:hover {
    background: #dadada !important;
  }
  .birthday-picker a:hover {
    color: #dadada !important;
  }
  button.close {
    color: #fff !important;
  }
  .card {
    background: #000 !important;
  }
  .card-header {
    background-color: #484848 !important;
    border-bottom: 1px solid #dadada !important;
  }
  .navbar,
  .bg-white {
    background-color: #000 !important;
  }
  label,
  h4,
  .text-muted {
    color: #fff !important;
  }
  /* Hides Light Mode-Only Content, Like Images */
  .light-img {
    display: none;
    display: none !important;
  }

  /* Custom Dark Mode Background Color */
  .darkmode {
    background-color: #272623 !important;
  }

  /* Custom Dark Mode Font Colors */
  h1,
  h2,
  p,
  span,
  a,
  b {
    color: #ffffff !important;
  }

  /* Custom Dark Mode Text Link Color */
  .link {
    color: #91add4 !important;
  }

  /*container for buttons */
  #buttons,
  .modal-content {
    background: #000 !important;
  }
}
/* Shows Dark Mode-Only Content, Like Images */
[data-ogsc] .dark-img {
  display: block !important;
  width: auto !important;
  overflow: visible !important;
  float: none !important;
  max-height: inherit !important;
  max-width: inherit !important;
  line-height: auto !important;
  margin-top: 0px !important;
  visibility: inherit !important;
}

/* Hides Light Mode-Only Content, Like Images */
[data-ogsc] .light-img {
  display: none;
  display: none !important;
}

/* Custom Dark Mode Background Color */
[data-ogsc] .darkmode {
  background-color: #272623 !important;
}

/* Custom Dark Mode Font Colors */
[data-ogsc] h1,
[data-ogsc] h2,
[data-ogsc] p,
[data-ogsc] span,
[data-ogsc] a,
[data-ogsc] b {
  color: #ffffff !important;
}

/* Custom Dark Mode Text Link Color */
[data-ogsc] .link {
  color: #91add4 !important;
}

.overlay {
  position: relative;
}

.overlay img {
  display: block;
}

.overlay svg {
  position: absolute;
  bottom: 0;
  left: 0;
}
/*
.btn-danger:focus,
.btn-danger.focus {
  color: #fff;
  background-color: #565a5c !important;
  border-color: #bd2130;
  border: 1px dotted #565a5c !important;
} */
</style>
